import moment from 'moment'

/**
 * campo.tipo -> configuração de coluna da listagem (field, formatação da célula).
 * Lookups usam o campo derivado `<nome>__descricao` retornado pelo backend (LEFT JOIN).
 */

export function buildColumnFor(campo) {
  const field = campo.tipo === 'lookup' ? `${campo.nome}__descricao` : campo.nome
  return {
    field,
    header: campo.label,
    columnKey: field,
    columnSortField: field,
    sortable: !!campo.ordenavel,
    filter: !!campo.filtro,
    visible: !!campo.listagem,
    tipoCampoCrud: campo.tipo,
    nomeCampoCrud: campo.nome,
  }
}

export function formatCell(rowData, column) {
  const valor = rowData[column.field]
  // boolean antes do guard de vazio: null/false exibem 'Não'
  if (column.tipoCampoCrud === 'boolean') {
    return valor === true || valor === 'true' ? 'Sim' : 'Não'
  }
  if (valor === null || valor === undefined || valor === '') {
    return ''
  }
  switch (column.tipoCampoCrud) {
    case 'date':
      return moment(valor).format('DD/MM/YYYY')
    case 'datetime':
      return moment(valor).format('DD/MM/YYYY HH:mm')
    case 'numeric':
      return Number(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    default:
      return String(valor)
  }
}
